import { render, staticRenderFns } from "./information-champ.vue?vue&type=template&id=426e9efe&scoped=true&"
import script from "./information-champ.vue?vue&type=script&lang=ts&"
export * from "./information-champ.vue?vue&type=script&lang=ts&"
import style0 from "./information-champ.vue?vue&type=style&index=0&id=426e9efe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426e9efe",
  null
  
)

export default component.exports